const actions = {
  GET_ALL_TRANSACTION: 'GET_ALL_TRANSACTION',
  GET_ALL_TRANSACTION_SUCCESS: 'GET_ALL_TRANSACTION_SUCCESS',
  GET_ALL_TRANSACTION_FAILED: 'GET_ALL_TRANSACTION_FAILED',
  RESET_ALL_TRANSACTION: 'RESET_ALL_TRANSACTION',


   GET_SUCCESS_SUMMARY: 'GET_SUCCESS_SUMMARY',
  GET_SUCCESS_SUMMARY_SUCCESS: 'GET_SUCCESS_SUMMARY_SUCCESS',
  GET_SUCCESS_SUMMARY_FAILED: 'GET_SUCCESS_SUMMARY_FAILED',
  RESET_SUCCESS_SUMMARY: 'RESET_SUCCESS_SUMMARY',

  getAllTransaction: (agentId) => ({
    type: actions.GET_ALL_TRANSACTION,
    payload: {agentId},
  }),

  getAllTransactionSuccess: (data) => ({
    type: actions.GET_ALL_TRANSACTION_SUCCESS,
    payload: { data },
  }),

  getAllTransactionFailed: (error) => ({
    type: actions.GET_ALL_TRANSACTION_FAILED,
    payload: { error },
  }),

  resetAllTransaction: () => ({
    type: actions.RESET_ALL_TRANSACTION,
  }),


   getSuccessSummary: (agentId) => ({
    type: actions.GET_SUCCESS_SUMMARY,
    payload: {agentId},
  }),
  getSuccessSummarySuccess: (data) => ({
    type: actions.GET_SUCCESS_SUMMARY_SUCCESS,
    payload: { data },
  }),
  getSuccessSummaryFailed: (error) => ({
    type: actions.GET_SUCCESS_SUMMARY_FAILED,
    payload: { error },
  }),
  resetSuccessSummary: () => ({
    type: actions.RESET_SUCCESS_SUMMARY,
  }),

};

export default actions;
